import React from "react";
import { DateFields, DateKey, MobileInputsProps } from "./types";

const MOBILE_DATE_FIELDS: DateFields = [
  { key: "month", labelKey: "Month", placeholder: "MM", maxLength: 2 },
  { key: "day", labelKey: "Day", placeholder: "DD", maxLength: 2 },
  { key: "year", labelKey: "Year", placeholder: "YYYY", maxLength: 4 },
];

const MobileInputs = ({
  t,
  inputDay,
  inputMonth,
  inputYear,
  handleChange,
  handleBlur,
  mobileRef,
  baseProps,
  rhfRef,
  hiddenValue,
}: MobileInputsProps) => {
  const { id: inputID } = baseProps;

  const valuesByKey: Record<DateKey, string> = {
    day: inputDay,
    month: inputMonth,
    year: inputYear,
  };

  return (
    <div
      className="input__fieldWrapper mobile-date DateInput_separated"
      onBlurCapture={handleBlur}
      ref={mobileRef}>
      <input
        type="hidden"
        ref={rhfRef as React.LegacyRef<HTMLInputElement>}
        value={hiddenValue}
      />
      {MOBILE_DATE_FIELDS.map(({ key, labelKey, placeholder, maxLength }) => (
        <div key={key}>
          <label
            htmlFor={`${inputID}-${key}`}
            className="input__label">
            {t[labelKey] || labelKey}
          </label>

          <input
            {...baseProps}
            id={`${inputID}-${key}`}
            className="input__field"
            placeholder={placeholder}
            type="text"
            value={valuesByKey[key]}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              handleChange({ [key]: e.currentTarget.value })
            }
            maxLength={maxLength}
            inputMode="numeric"
          />
        </div>
      ))}
    </div>
  );
};

export default MobileInputs;
